var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnclaimedUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:none;stroke:#000000;stroke-width:5.000000e-02;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid_system"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,6.6c0-2.4-2-4.4-4.5-4.4s-4.5,2-4.5,4.4C7.5,9,9.5,11,12,11S16.5,9,16.5,6.6z M9.5,6.6c0-1.3,1.1-2.4,2.5-2.4   s2.5,1.1,2.5,2.4S13.4,9,12,9S9.5,7.9,9.5,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6,16.3l-0.5,1.9c-0.3,0.9-0.1,1.9,0.5,2.7C5.2,21.6,6,22,7,22h6.9c0.6,0,1-0.4,1-1s-0.4-1-1-1H7c-0.4,0-0.6-0.2-0.7-0.4   C6,19.4,5.9,19,6,18.7l0.5-1.9C7,15.1,8.4,14,10,14H14c0.8,0,1.6,0.3,2.3,0.8c0.4,0.4,1.1,0.3,1.4-0.1c0.4-0.4,0.3-1.1-0.1-1.4   c-1-0.8-2.3-1.3-3.6-1.3H10C7.5,12,5.3,13.7,4.6,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,16.9c-0.4-0.4-1-0.4-1.4,0L18,17.6l-0.7-0.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l0.7,0.7l-0.7,0.7   c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l0.7-0.7l0.7,0.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L19.4,19l0.7-0.7C20.5,17.9,20.5,17.3,20.1,16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnclaimedUser);
export default __webpack_public_path__ + "static/media/unclaimed-user.7e0ee0910347cdb7a2f6b97e710daf3b.svg";
export { ForwardRef as ReactComponent };